module.exports = __webpack_public_path__ + "img/1.500bfa8f.jpg";